import React from 'react';
import { useSpring, animated } from '@react-spring/web';
import { useInView } from 'react-intersection-observer';
import './HivePricing.css';

const packages = [
  {
    name: 'The Local Hive (Starter)',
    description: 'Perfect for new and local businesses.',
    creativeAssets: '3 Creative Assets',
    views: '60,000',
    viewsNote: 'guaranteed total views (R0.12 effective CPV)',
    totalCost: 'R7,200',
    popular: false,
  },
  {
    name: 'The Growth Hive',
    description: 'Designed for expanding SMEs.',
    creativeAssets: '5 Creative Assets',
    views: '100,000',
    viewsNote: 'guaranteed total views (R0.115 effective CPV)',
    totalCost: 'R11,500',
    popular: true,
  },
  {
    name: 'The Takeover Hive',
    description: 'The ultimate growth engine.',
    creativeAssets: '8 Creative Assets',
    views: '150,000',
    viewsNote: 'guaranteed total views (R0.11 effective CPV)',
    totalCost: 'R16,500',
    popular: false,
  },
];

const HivePricingCard = ({ pkg, onEnquire, delay }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const animationProps = useSpring({
    transform: inView ? 'scale(1)' : 'scale(0.9)',
    opacity: inView ? 1 : 0,
    delay: inView ? delay : 0,
    config: { tension: 170, friction: 20 },
  });

  return (
    <animated.article
      ref={ref}
      style={animationProps}
      className={`hive-pricing-card${pkg.popular ? ' hive-pricing-card-popular' : ''}`}
    >
      {pkg.popular && (
        <span className="hive-pricing-popular-badge">Most Popular</span>
      )}

      <div className="hive-pricing-card-header">
        <h3 className="hive-pricing-card-title">{pkg.name}</h3>
        <p className="hive-pricing-card-description">{pkg.description}</p>
      </div>

      <div className="hive-pricing-card-body">
        <p className="hive-pricing-card-detail">{pkg.creativeAssets}</p>
        <p className="hive-pricing-views">{pkg.views}</p>
        <p className="hive-pricing-card-detail">{pkg.viewsNote}</p>
        <p className="hive-pricing-card-detail hive-pricing-card-detail-spaced">
          Total Cost to brand
        </p>
        <p className="hive-pricing-total">{pkg.totalCost}</p>
      </div>

      <a
        href="#hive-enquire"
        className="hive-pricing-button"
        onClick={() => onEnquire?.(pkg.name.replace(' (Starter)', ''))}
      >
        Enquire Now
      </a>
    </animated.article>
  );
};

const HivePricing = ({ onEnquire }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const headingAnimation = useSpring({
    transform: inView ? 'translateY(0px)' : 'translateY(30px)',
    opacity: inView ? 1 : 0,
    config: { tension: 170, friction: 20 },
  });

  return (
    <div className="hive-pricing">
      <animated.h2
        ref={ref}
        style={headingAnimation}
        className="hive-pricing-heading"
      >
        Pricing
      </animated.h2>
      <div className="hive-pricing-grid">
        {packages.map((pkg, index) => (
          <HivePricingCard
            key={pkg.name}
            pkg={pkg}
            onEnquire={onEnquire}
            delay={index * 120}
          />
        ))}
      </div>
      <p className="hive-pricing-footnote">
        Optional Power Ups &amp; Add ons available. Videographer capture | Views
        Boost | Google Brand Profile Usage | Community Management
      </p>
    </div>
  );
};

export default HivePricing;
